'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  event: {
    entities: {
      audiences: 'Publics',
      events: 'Événements',
      regions: 'Quartiers',
      types: 'Types',
      tags: 'Mots-clés',
      venues: 'Lieux',
      organizations: 'Organisations'
    },
    entitiesAll: {
      audiences: 'Tous les publics',
      events: 'Tous les événements',
      regions: 'Tous les quartiers',
      types: 'Par type',
      tags: 'Par mot-clé',
      venues: 'Par lieu',
      organizations: 'Par groupe'
    },
    entityDescriptions: {
      types: 'Cette liste présente les types associés aux événements actuellement inscrits au calendrier.',
      tags: 'Cette liste présente les mots-clés associés aux événements actuellement inscrits au calendrier.',
      venues: 'Cette liste présente les lieux où se déroulent les événements actuellement inscrits au calendrier.',
      organizations: 'Cette liste présente les groupes ayant des événements inscrits au calendrier.'
    },
    hideRepeatingEvents: 'Masquer les répétitions',
    recurringEvents: 'Événements récurrents',
    showAll: 'Afficher les %{entity} sans événements',
    treeView: 'Afficher la hiérarchie',
    collapseEntity: 'Masquer les sous-éléments',
    expandEntity: 'Afficher les sous-éléments'
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr/event.js
// module id = 1144
// module chunks = 0